export const VIDEO_PASSWORD = 'BilagSkySpace';
